import type { Enums, Tables } from "../types";
import { calculateBooking } from "./calculate-booking-minutes";

/**
 * This function calculates the result of a booking check.
 * @param booking
 * @param adjustment
 * @returns
 */
export function getBookingCheckResult(
	booking: Pick<Tables<"ticketAssignmentReferenceBookings">, "checkIn" | "checkOut" | "pause">,
	adjustment: Omit<
		Tables<"ticketAssignmentReferenceBookingsAdjustments">,
		"createdAt" | "createdBy"
	> | null,
): Enums<"bookingResult"> | null {
	/** Guards */
	if (!booking) return null;
	if (!adjustment) return null;
	if (calculateBooking(adjustment) === undefined) return null;
	if (calculateBooking(adjustment) === null) return null;

	/** Calculate if on is rejected */
	if (calculateBooking(adjustment) === 0 && calculateBooking(booking) !== 0) {
		return "rejected";
	}

	/** Calculate if adjusted or accepted */
	const keys = ["checkIn", "checkOut", "pause"] as const;
	for (const key of keys) {
		if (booking[key] !== adjustment?.[key]) {
			return "adjusted";
		}
	}
	return "accepted";
}
